import { render, staticRenderFns } from "./PortfoliosToInvestNavbar.vue?vue&type=template&id=4867ad1f&"
import script from "./PortfoliosToInvestNavbar.vue?vue&type=script&lang=ts&"
export * from "./PortfoliosToInvestNavbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports